<script setup lang="ts">
import { computed } from "vue";
import { quillDeltaToHtml } from "@/common/utils/quill";
import { styleZoom } from "@/common/utils/style";

const props = defineProps<{
  company: any;
  data: any;
  print?: boolean;
  style: any;
  zoom: number;
}>();

const text = computed(() => {
  if (props.data.text) {
    return quillDeltaToHtml(props.data.text);
  }
  return "";
});
</script>

<template>
  <div
    class="page"
    :class="{
      print: props.print,
    }"
    :style="styleZoom(style, zoom)"
  >
    <div class="page-content">
      <template v-if="company?.avatar">
        <div class="avatar">
          <img
            :src="company.avatar.base64"
            alt="avatar"
            :style="
              styleZoom(
                {
                  'max-width': '150px',
                },
                zoom,
              )
            "
          />
        </div>
        <div
          class="text"
          v-html="text"
          :style="
            styleZoom(
              {
                'text-align': data.align,
                'font-size': data.size,
                'font-family': data.font_family,
              },
              zoom,
            )
          "
        ></div>
      </template>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.page {
  display: flex;
  flex-direction: column;
  margin-inline: auto;
  margin-bottom: 20px;
  position: relative;
  transition: all 0.3s ease;

  &.print {
    width: 210mm !important;
    height: 296.75mm !important;
    max-height: 296.75mm !important;
    overflow: hidden;
    border: 0px;
    font-size: 16px;
    margin-bottom: 0;
  }

  .page-content {
    display: flex;
    flex-direction: column;
    gap: 1em;
    margin-top: auto;
    margin-bottom: auto;

    .avatar {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 1em;

      img {
        border-radius: 0.5em;
        max-width: 100%;
        object-fit: contain;
      }
    }
  }
}
</style>
